import React from 'react';
import { motion } from 'framer-motion';
import { FaTelegram } from 'react-icons/fa6';
import './SocialStats.css';

const SocialStats: React.FC = () => {
  return (
    <section className="trading-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="trading-header"
        >
          <h2 className="section-title">Trading Eğitimi</h2>
          <p className="section-subtitle">Profesyonel trading stratejileri ve canlı sinyaller</p>
        </motion.div>

        <motion.div 
          className="trading-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* Sol taraf - Fotoğraf */}
          <div className="trading-image-side">
            <img src="/trading.jpeg" alt="Trading" />
          </div>

          {/* Sağ taraf - Bilgiler */}
          <div className="trading-info-side">
            <div className="trading-telegram-card">
              <div className="telegram-header">
                <FaTelegram className="telegram-icon" />
                <span>Telegram Grubumuz</span>
              </div>
              <h3 className="trading-cta-title">Telegram Grubumuza Katılmak İçin Hemen İletişime Geçin</h3>
              <p className="trading-desc">
                Canlı trading sinyalleri, piyasa analizleri ve özel eğitim içerikleri için Telegram grubumuza katılın.
              </p>
              <a 
                href="https://wa.me/905337757181" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="trading-contact-btn"
              >
                İletişime Geç
              </a>
            </div>

            <div className="trading-price-card">
              <span className="price-badge">Aylık Üyelik</span>
              <div className="price-amount">
                <span className="price-value">150.000</span>
                <span className="price-currency">₺</span>
                <span className="price-period">/ ay</span>
              </div>
              <ul className="price-features">
                <li>✓ Günlük trading sinyalleri</li>
                <li>✓ Canlı piyasa analizleri</li>
                <li>✓ VIP Telegram grubu erişimi</li>
                <li>✓ 1'e 1 destek</li>
              </ul>
              <a 
                href="https://wa.me/905337757181" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="price-cta-btn"
              >
                Hemen Başla
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialStats;
